import { render, staticRenderFns } from "./BookingExtensionForm.vue?vue&type=template&id=16ccb7de&"
import script from "./BookingExtensionForm.vue?vue&type=script&lang=js&"
export * from "./BookingExtensionForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports